// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".switch-input[data-v-6f69ca5b] {\n  color: var(--green);\n}\n.switch-input label[data-v-6f69ca5b] {\n  cursor: pointer;\n  font-size: 0.9rem;\n  font-weight: 500;\n  padding: 0;\n  margin: 0;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
